import React, {useEffect, useState} from 'react';
import CommentsList from './CommentsList';
import AddComments from './AddComments';
import './Comments.scss';

const Comments = (props) => {
  const {activeRisk, id, defaultData} = props;
  const [commentAdded, setCommentAdded] = useState(0);
  useEffect(() => {
  }, [defaultData]);
  return (
    <div className="document-comments w-100">
      <CommentsList
        activeRisk={activeRisk}
        commentAdded={commentAdded}
        key={'commentsList'}
        id={id}
      />
      {defaultData?.active === true &&
        <AddComments
          commentAdded={() => setCommentAdded(commentAdded + 1)}
          activeRisk={activeRisk}
          key={'addComment'}
          id={id}
        />}
    </div>
  );
};

export default Comments;
